module.exports = __webpack_public_path__ + "static/media/diamond.3207d1ff.png";